// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FeatureFlagsDTOAPIModel,
    FeatureFlagsDTOAPIModelFromJSON,
    FeatureFlagsDTOAPIModelToJSON,
} from '../models';

/**
 * ToggleApi - interface
 * 
 * @export
 * @interface ToggleApiInterface
 */
export interface ToggleApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToggleApiInterface
     */
    toggleControllerGetFlagsRaw(): Promise<runtime.ApiResponse<FeatureFlagsDTOAPIModel>>;

    /**
     */
    toggleControllerGetFlags(): Promise<FeatureFlagsDTOAPIModel>;

}

/**
 * 
 */
export class ToggleApi extends runtime.BaseAPI implements ToggleApiInterface {

    /**
     */
    async toggleControllerGetFlagsRaw(): Promise<runtime.ApiResponse<FeatureFlagsDTOAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/toggle/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureFlagsDTOAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async toggleControllerGetFlags(): Promise<FeatureFlagsDTOAPIModel> {
        const response = await this.toggleControllerGetFlagsRaw();
        return await response.value();
    }

}
